export default ["teacher", "manager", "moderator", "admin", "superadmin"];
